import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  TextField,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Typography,
  Skeleton,
  Select,
  MenuItem as SelectMenuItem,
  Pagination,
  Button,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import {
  Search as SearchIcon,
  Add as AddIcon,
  ArrowBack as ArrowBackIcon,
  MoreVert as MoreVertIcon,
  Visibility as VisibilityIcon,
  CardMembership as CardMembershipIcon,
  Description as DescriptionIcon,
  ConfirmationNumber as ConfirmationNumberIcon,
  ArrowDropDown as ArrowDropDownIcon,
  History as HistoryIcon,
  PersonAdd as PersonAddIcon,
} from "@mui/icons-material";
import axios from "axios";
import { BASE_URL } from "../../../services/configUrls";

import CreateMembershipForm from "./MembrshipCreation";
import ViewFeaturesModal from "./ViewFeatureModal";
import ViewMembershipModal from "./MembershipModal";
import ViewMOUModal from "./ViewMOUModal";
import AddTopUpModal from "./AddTopUpModal";
import ViewTopUpModal from "./ViewTopUpModal"; 
import RenewalHistoryModal from "./RenewalHistoryModal";
import TopUpHistoryModal from "./TopUpHistoryModal";
import AssignTrainerModal from "./AssignTrainerModal";

const InstituteMemberships = () => {
  const [institutes, setInstitutes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [searchInput, setSearchInput] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedInstitute, setSelectedInstitute] = useState(null);
  const [viewFeaturesOpen, setViewFeaturesOpen] = useState(false);
  const [selectedInstituteId, setSelectedInstituteId] = useState(null);
  const [viewMembershipOpen, setViewMembershipOpen] = useState(false);
  const [selectedInstituteForMembership, setSelectedInstituteForMembership] =
    useState(null);
  const [viewMOUOpen, setViewMOUOpen] = useState(false);
  const [selectedInstituteForMOU, setSelectedInstituteForMOU] = useState(null);
  const [addTopUpOpen, setAddTopUpOpen] = useState(false);
  const [selectedInstituteForTopUp, setSelectedInstituteForTopUp] = useState(null);
  const [viewTopUpOpen, setViewTopUpOpen] = useState(false);
  const [selectedInstituteForTopUpView, setSelectedInstituteForTopUpView] = useState(null);
  const [topupInstituteIds, setTopupInstituteIds] = useState([]);
  //Renewal/top-up history
  const [historyAnchorEl, setHistoryAnchorEl] = useState(null);
  const [renewalOpen, setRenewalOpen] = useState(false);
  const [topUpHistoryOpen, setTopUpHistoryOpen] = useState(false);
  const [assignTrainerOpen, setAssignTrainerOpen] = useState(false);
  const [selectedInstituteForTrainer, setSelectedInstituteForTrainer] = useState(null);

  useEffect(() => {
    if (!showForm) {
      fetchInstitutes();
    }
  }, [page, pageSize, searchInput, showForm]);

  // Fetch which institutes have topups
  const fetchTopupStatus = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/accounts/topup_status`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      setTopupInstituteIds(response.data || []);
    } catch (err) {
      console.error("Error fetching topup status:", err);
    }
  };

  useEffect(() => {
    fetchTopupStatus();
  }, []);

  const fetchInstitutes = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/accounts/institutes-basic`,
        {
          params: {
            search: searchInput,
            page: page + 1,
            page_size: pageSize,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );

      setInstitutes(response.data.institutes || []);
      setTotalCount(response.data.total || 0);
    } catch (error) {
      console.error("Error fetching institutes:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchInput(value);
    setPage(0);
  };

  const handlePageChange = (event, value) => {
    setPage(value - 1);
  };

  const handlePageSizeChange = (event) => {
    setPageSize(event.target.value);
    setPage(0);
  };

  const handleShowForm = () => {
    setShowForm(true);
  };

  const handleBackToTable = () => {
    setShowForm(false);
    fetchInstitutes();
  };
  // ADD TOP UP HandleAddTopUp 
 const handleAddTopUp = () => {
  console.log("Add Top Up");
  setSelectedInstituteForTopUp(selectedInstitute); // store full object
  setViewTopUpOpen(false);
  setTopUpHistoryOpen(false);
  setRenewalOpen(false);
  setAddTopUpOpen(true);
    handleMenuClose();
  };
const handleViewTopUp = () => {
  setSelectedInstituteForTopUpView(selectedInstitute);
  setAddTopUpOpen(false);
  setTopUpHistoryOpen(false);
  setRenewalOpen(false);
  setViewTopUpOpen(true);
  handleMenuClose();
};

//FOR RENEWAL/TOP-UP HISTORY
const handleHistoryClick = (event) => {
  setHistoryAnchorEl(event.currentTarget);
};

const handleHistoryClose = () => {
  setHistoryAnchorEl(null);
};

const handleRenewalHistory = () => {
  setAddTopUpOpen(false);
  setViewTopUpOpen(false);
  setTopUpHistoryOpen(false);
  setRenewalOpen(true);
  handleHistoryClose();
};
const handleTopUpHistory = () => {
  setAddTopUpOpen(false);
  setViewTopUpOpen(false);
  setRenewalOpen(false);
  setTopUpHistoryOpen(true);
  handleHistoryClose();
};

  const handleMenuClick = (event, institute) => {
    setAnchorEl(event.currentTarget);
    setSelectedInstitute(institute);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedInstitute(null);
  };

  const handleViewFeatures = () => {
    setSelectedInstituteId(selectedInstitute.institue_id);
    setViewFeaturesOpen(true);
    handleMenuClose();
  };

  const handleViewMembership = () => {
    setSelectedInstituteForMembership(selectedInstitute.institue_id);
    setViewMembershipOpen(true);
    handleMenuClose();
  };

  const handleViewMOU = () => {
    // Store the entire institute object to access both institute_id and membership_id
    setSelectedInstituteForMOU(selectedInstitute);
    setViewMOUOpen(true);
    handleMenuClose();
  };

  const handleAssignTrainer = () => {
    setSelectedInstituteForTrainer(selectedInstitute);
    setAssignTrainerOpen(true);
    handleMenuClose();
  };

  const handleCloseAssignTrainerModal = () => {
    setAssignTrainerOpen(false);
    setSelectedInstituteForTrainer(null);
  };

  const handleCloseFeaturesModal = () => {
    setViewFeaturesOpen(false);
    setSelectedInstituteId(null);
  };

  const handleCloseMembershipModal = () => {
    setViewMembershipOpen(false);
    setSelectedInstituteForMembership(null);
  };

  const handleCloseMOUModal = () => {
    setViewMOUOpen(false);
    setSelectedInstituteForMOU(null);
  };

  const totalPages = Math.ceil(totalCount / pageSize);

  // Skeleton row component
  const SkeletonRow = () => (
    <TableRow>
      <TableCell sx={{ py: 2 }}>
        <Skeleton variant="text" width="80%" height={20} />
      </TableCell>
      <TableCell sx={{ py: 2 }}>
        <Skeleton variant="text" width="70%" height={20} />
      </TableCell>
      <TableCell sx={{ py: 2 }}>
        <Skeleton variant="rounded" width={80} height={24} />
      </TableCell>
      <TableCell sx={{ py: 2 }}>
        <Skeleton variant="text" width="60%" height={20} />
      </TableCell>
      <TableCell sx={{ py: 2 }}>
        <Skeleton variant="text" width="60%" height={20} />
      </TableCell>
      <TableCell sx={{ py: 2 }}>
        <Skeleton variant="text" width="60%" height={20} />
      </TableCell>
      <TableCell align="center" sx={{ py: 2 }}>
        <Skeleton
          variant="circular"
          width={32}
          height={32}
          sx={{ mx: "auto" }}
        />
      </TableCell>
    </TableRow>
  );

  // If form is shown, render the form with back button
  if (showForm) {
    return (
      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            mb: 2,
            px: 3,
            pt: 3,
          }}
        >
          <IconButton
            onClick={handleBackToTable}
            sx={{
              color: "#6B7280",
              "&:hover": {
                backgroundColor: "#F3F4F6",
              },
            }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: 600,
              color: "#1F1F1F",
            }}
          >
            Add Subscription
          </Typography>
        </Box>
        <CreateMembershipForm onSuccess={handleBackToTable} />
      </Box>
    );
  }

  // Otherwise render the table
  return (
    <Box sx={{ p: 3 }}>
      <Paper
        sx={{
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
          border: "1px solid #E5E7EB",
          borderRadius: "6px",
        }}
      >
        {/* Header with Search and Add Button */}
        <Box
          sx={{
            p: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderBottom: "1px solid #E5E7EB",
          }}
        >
          <Typography
            sx={{
              fontSize: "15px",
              fontWeight: 600,
              color: "#1F1F1F",
            }}
          >
            Institute Memberships ({totalCount})
          </Typography>

          <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
            <TextField
              size="small"
              placeholder="Search institutes..."
              value={searchInput}
              onChange={handleSearchChange}
              sx={{
                width: "280px",
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "#F9FAFB",
                  fontSize: "13px",
                  "& fieldset": {
                    borderColor: "#E5E7EB",
                  },
                  "&:hover fieldset": {
                    borderColor: "#D1D5DB",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#3B82F6",
                  },
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ fontSize: 18, color: "#9CA3AF" }} />
                  </InputAdornment>
                ),
              }}
            />

            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={handleShowForm}
              sx={{
                backgroundColor: "#3B82F6",
                "&:hover": { backgroundColor: "#2563EB" },
                textTransform: "none",
                fontSize: "13px",
                fontWeight: 500,
                boxShadow: "none",
              }}
            >
              Add Subscription
            </Button>
            {/* NEW: History Dropdown Button */}
          <>
        <Button
          variant="outlined"
          startIcon={<HistoryIcon />}
          endIcon={<ArrowDropDownIcon />}
          onClick={handleHistoryClick}
          sx={{
            backgroundColor: "#3B82F6",
            color: "#FFFFFF",
            "&:hover": { backgroundColor: "#2563EB", color: "#FFFFFF" },
            textTransform: "none",
            fontSize: "13px",
            fontWeight: 500,
            boxShadow: "none",
            "& .MuiSvgIcon-root": { color: "#FFFFFF" },
          }}
        >
          History
        </Button>

        <Menu
          anchorEl={historyAnchorEl}
          open={Boolean(historyAnchorEl)}
          onClose={handleHistoryClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          PaperProps={{
            elevation: 3,
            sx: {
              minWidth: "180px",
              mt: 0.5,
              "& .MuiMenuItem-root": {
                fontSize: "13px",
                py: 1,
              },
            },
          }}
        >
    <MenuItem onClick={handleRenewalHistory}>
    <DescriptionIcon sx={{ fontSize: 18, mr: 1.5, color: "#6B7280" }} />
    Renewal
  </MenuItem>

  <MenuItem onClick={handleTopUpHistory}>
    <ConfirmationNumberIcon sx={{ fontSize: 18, mr: 1.5, color: "#6B7280" }} />
    Top Up
  </MenuItem>
        </Menu>
</>
          </Box>
        </Box>

        {/* Table */}
        <TableContainer>
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "#FAFAFA",
                  "& th": {
                    borderBottom: "1px solid #E5E7EB",
                  },
                }}
              >
                <TableCell
                  sx={{
                    fontWeight: 600,
                    fontSize: "12px",
                    color: "#6B7280",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    py: 1.5,
                  }}
                >
                  Institute Name
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: 600,
                    fontSize: "12px",
                    color: "#6B7280",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    py: 1.5,
                  }}
                >
                  State
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: 600,
                    fontSize: "12px",
                    color: "#6B7280",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    py: 1.5,
                  }}
                >
                  Institute Status
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: 600,
                    fontSize: "12px",
                    color: "#6B7280",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    py: 1.5,
                  }}
                >
                  Membership Name
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: 600,
                    fontSize: "12px",
                    color: "#6B7280",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    py: 1.5,
                  }}
                >
                  Membership No.
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: 600,
                    fontSize: "12px",
                    color: "#6B7280",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    py: 1.5,
                  }}
                >
                  Assigned Trainer
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: 600,
                    fontSize: "12px",
                    color: "#6B7280",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    textAlign: "center",
                    py: 1.5,
                    width: "80px",
                  }}
                >
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                // Show skeleton rows when loading
                Array.from(new Array(pageSize)).map((_, index) => (
                  <SkeletonRow key={index} />
                ))
              ) : institutes.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={7} align="center" sx={{ py: 8 }}>
                    <Typography
                      color="text.secondary"
                      fontSize="13px"
                      sx={{ fontWeight: 400 }}
                    >
                      No institutes found
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                institutes.map((institute) => (
                  <TableRow
                    key={institute.institue_id}
                    hover
                    sx={{
                      "&:hover": {
                        backgroundColor: "#F9FAFB",
                      },
                      "& td": {
                        borderBottom: "1px solid #F3F4F6",
                      },
                      "&:last-child td": {
                        borderBottom: "none",
                      },
                    }}
                  >
                    <TableCell
                      sx={{
                        fontSize: "13px",
                        color: "#1F1F1F",
                        fontWeight: 500,
                        py: 2,
                      }}
                    >
                      {institute.institute_name}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: "13px",
                        color: "#6B7280",
                        py: 2,
                      }}
                    >
                      {institute.state_name || "-"}
                    </TableCell>
                    <TableCell sx={{ py: 2 }}>
                      <Chip
                        label={
                          institute.is_active === "1" ? "Active" : "Inactive"
                        }
                        size="small"
                        sx={{
                          fontSize: "11px",
                          height: "24px",
                          fontWeight: 500,
                          backgroundColor:
                            institute.is_active === "1" ? "#DCFCE7" : "#FEE2E2",
                          color:
                            institute.is_active === "1" ? "#15803D" : "#991B1B",
                          border: "none",
                        }}
                      />
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: "13px",
                        color: "#6B7280",
                        py: 2,
                      }}
                    >
                      {institute.membership_name || "-"}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: "13px",
                        color: "#6B7280",
                        py: 2,
                      }}
                    >
                      {institute.membership_no || "-"}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: "13px",
                        color: "#6B7280",
                        py: 2,
                      }}
                    >
                      {institute.trainer_name || "N/A"}
                    </TableCell>
                    <TableCell align="center" sx={{ py: 2 }}>
                      <IconButton
                        size="small"
                        onClick={(e) => handleMenuClick(e, institute)}
                        sx={{
                          color: "#6B7280",
                          "&:hover": {
                            backgroundColor: "#F3F4F6",
                          },
                        }}
                      >
                        <MoreVertIcon sx={{ fontSize: 20 }} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Custom Pagination Footer */}
        <Box
          sx={{
            borderTop: "1px solid #E5E7EB",
            px: 2,
            py: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {/* Left side - Rows per page */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography sx={{ fontSize: "13px", color: "#6B7280" }}>
              Rows per page:
            </Typography>
            <Select
              value={pageSize}
              onChange={handlePageSizeChange}
              size="small"
              sx={{
                fontSize: "13px",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#E5E7EB",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#D1D5DB",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#3B82F6",
                },
                "& .MuiSelect-select": {
                  py: 0.5,
                  pr: 3,
                },
              }}
            >
              <SelectMenuItem value={5} sx={{ fontSize: "13px" }}>
                5
              </SelectMenuItem>
              <SelectMenuItem value={10} sx={{ fontSize: "13px" }}>
                10
              </SelectMenuItem>
              <SelectMenuItem value={20} sx={{ fontSize: "13px" }}>
                20
              </SelectMenuItem>
              <SelectMenuItem value={50} sx={{ fontSize: "13px" }}>
                50
              </SelectMenuItem>
            </Select>
          </Box>

          {/* Center - Page info */}
          <Typography sx={{ fontSize: "13px", color: "#6B7280" }}>
            {totalCount === 0
              ? "0 of 0"
              : `${page * pageSize + 1}-${Math.min(
                  (page + 1) * pageSize,
                  totalCount
                )} of ${totalCount}`}
          </Typography>

          {/* Right side - Page numbers */}
          <Pagination
            count={totalPages}
            page={page + 1}
            onChange={handlePageChange}
            shape="rounded"
            size="small"
            siblingCount={1}
            boundaryCount={1}
            sx={{
              "& .MuiPaginationItem-root": {
                fontSize: "13px",
                minWidth: "32px",
                height: "32px",
                color: "#6B7280",
                "&:hover": {
                  backgroundColor: "#F3F4F6",
                },
                "&.Mui-selected": {
                  backgroundColor: "#3B82F6",
                  color: "#FFFFFF",
                  "&:hover": {
                    backgroundColor: "#2563EB",
                  },
                },
              },
              "& .MuiPaginationItem-previousNext": {
                color: "#6B7280",
              },
            }}
          />
        </Box>

        {/* Action Menu */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          PaperProps={{
            elevation: 3,
            sx: {
              minWidth: "180px",
              mt: 0.5,
              "& .MuiMenuItem-root": {
                fontSize: "13px",
                py: 1,
              },
            },
          }}
        >

          {selectedInstitute && selectedInstitute.is_active === "1" && (
          <MenuItem onClick={handleAddTopUp}>
            <AddIcon sx={{ fontSize: 18, mr: 1.5, color: "#6B7280" }} />
            <span style={{ color: "green" }}>
              Top Up
            </span> 
          </MenuItem>
          )}
          <MenuItem onClick={handleAssignTrainer}>
            <PersonAddIcon sx={{ fontSize: 18, mr: 1.5, color: "#6B7280" }} />
            Assign Trainer
          </MenuItem>
          <MenuItem onClick={handleViewFeatures}>
            <VisibilityIcon sx={{ fontSize: 18, mr: 1.5, color: "#6B7280" }} />
            View Features
          </MenuItem>
          <MenuItem onClick={handleViewMembership}>
            <CardMembershipIcon
              sx={{ fontSize: 18, mr: 1.5, color: "#6B7280" }}
            />
            View Membership
          </MenuItem>
          <MenuItem onClick={handleViewMOU}>
            <DescriptionIcon sx={{ fontSize: 18, mr: 1.5, color: "#6B7280" }} />
            View MOU
          </MenuItem>
          {selectedInstitute && topupInstituteIds.includes(selectedInstitute.institue_id) && (
           <MenuItem onClick={handleViewTopUp}>
           <ConfirmationNumberIcon sx={{ fontSize: 18, mr: 1.5, color: "#6B7280" }} />
            View Top Up
           </MenuItem>
          )}
        </Menu>
      </Paper>

      {/* Top Up Modal */}
      <AddTopUpModal
        open={addTopUpOpen}
        onClose={() => setAddTopUpOpen(false)}
        institute={selectedInstituteForTopUp}
        onSuccess={fetchTopupStatus}
      />

      {/* View Top Up Modal */}
      <ViewTopUpModal
        open={viewTopUpOpen}
        onClose={() => setViewTopUpOpen(false)}
        institute={selectedInstituteForTopUpView}
/>

      {/* View Features Modal */}
      <ViewFeaturesModal
        open={viewFeaturesOpen}
        onClose={handleCloseFeaturesModal}
        instituteId={selectedInstituteId}
      />

      {/* View Membership Modal */}
      <ViewMembershipModal
        open={viewMembershipOpen}
        onClose={handleCloseMembershipModal}
        instituteId={selectedInstituteForMembership}
      />

      {/* View MOU Modal - Updated to pass both instituteId and membershipId */}
      <ViewMOUModal
        open={viewMOUOpen}
        onClose={handleCloseMOUModal}
        instituteId={selectedInstituteForMOU?.institue_id}
        membershipId={selectedInstituteForMOU?.membership_id}
      />
      {/* Assign Trainer Modal */}
      <AssignTrainerModal
        open={assignTrainerOpen}
        onClose={handleCloseAssignTrainerModal}
        institute={selectedInstituteForTrainer}
        onSuccess={fetchInstitutes}
      />
      {/* RENEWAL AND TOPUP HISTORY MODAL */}
      <RenewalHistoryModal
        open={renewalOpen}
        onClose={() => setRenewalOpen(false)}
      />
      <TopUpHistoryModal
        open={topUpHistoryOpen}
        onClose={() => setTopUpHistoryOpen(false)}
      />
    </Box>
  );
};

export default InstituteMemberships;
